import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { FaFacebookF } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import api from '../services/api';
import './FacebookButton.css';

const FACEBOOK_URL_DIOCESIS = 'https://www.facebook.com/Diocesisdeipialesoficial/';

const FacebookButton = () => {
  const location = useLocation();

  const { data: config = {} } = useQuery({
    queryKey: ['configuracion'],
    queryFn: async () => {
      try {
        const response = await api.get('/configuracion');
        return response.data;
      } catch {
        return {};
      }
    },
    retry: false,
    staleTime: 10 * 60 * 1000,
  });

  const facebookUrl = (config.facebook_url && !config.facebook_url.includes('Guachucal'))
    ? config.facebook_url
    : FACEBOOK_URL_DIOCESIS;

  if (location.pathname.includes('/repositorio-upload') || location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <a
      href={facebookUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="facebook-fab"
      aria-label="Síguenos en Facebook"
      title="Síguenos en Facebook"
    >
      <FaFacebookF />
    </a>
  );
};

export default FacebookButton;
